import * as React from "react";
import { ITextInputElement } from "@graffer-inc/form-schema";
import { TextButton } from "@graffer-inc/console-design-kit";
import { TenantProcessResultInputElementRow } from "./input-element-row";

type TenantProcessResultInputElementsEditorProps = {
  isReadonly: boolean;
  inputElements: ITextInputElement[];
  maxInputElements: number;
  onUpdate: (index: number, element: ITextInputElement) => void;
  onDelete: (index: number) => void;
  onCreate: () => void;
};

export const TenantProcessResultInputElementsEditor: React.FC<
  TenantProcessResultInputElementsEditorProps
> = ({
  isReadonly,
  inputElements,
  maxInputElements,
  onUpdate,
  onDelete,
  onCreate,
}) => {
  return (
    <div
      style={{
        maxWidth: "1000px",
      }}
    >
      <table className="table is-fullwidth">
        <thead>
          <tr>
            <th
              style={{
                width: "25%",
              }}
            >
              項目名
              <span className="tag is-rounded has-text-weight-bold ml-1">
                必須
              </span>
            </th>
            <th>説明文</th>
            <th
              style={{
                width: "15%",
              }}
            >
              詳細設定
            </th>
            <th aria-label="削除"></th>
          </tr>
        </thead>
        <tbody>
          {inputElements.map((element, index) => (
            <TenantProcessResultInputElementRow
              isReadonly={isReadonly}
              key={element.id}
              element={element}
              rowIndex={index}
              onUpdate={onUpdate}
              onDelete={onDelete}
            />
          ))}
          {!isReadonly && (
            <tr>
              <td colSpan={4}>
                <p className="help has-text-weight-normal mb-1">
                  最大で{maxInputElements}項目まで設定できます。
                </p>
                {inputElements.length < maxInputElements && (
                  <TextButton
                    text="追加"
                    icon="PlusCircleSolidIcon"
                    onClick={onCreate}
                  />
                )}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
